import { jsx as _jsx } from "react/jsx-runtime";
import { Paper, useTheme } from "@mui/material";
/**
 * Shared wrapping Paper for Delivery and Pickup sections of the Location page.
 *
 * @returns
 */
export const LocationSectionPaper = ({ children }) => {
    const theme = useTheme();
    return (_jsx(Paper, Object.assign({ sx: {
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(3),
            rowGap: theme.spacing(2),
        }, elevation: 2 }, { children: children })));
};
